const INITIAL_STATE = {
  data: {},
  errors: {},
}
  
const getWorkOrderList = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_WORK_ORDER_LIST':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'GET_WORK_ORDER_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
  
export default getWorkOrderList;
  